import { resolve } from "path"

const logs = function (...args: unknown[]) {
    console.log('HLS:', ...args)
}

interface IM3U8Segment {
    /** ts文件名 */
    uri: string
    /** 当前ts切片时长（秒） */
    duration: number
    timeline: number
}

export interface IM3U8ParsedInfo {
    allowCache: boolean
    endList: boolean
    mediaSqeuence: number
    /** ts文件信息列表 */
    segments: IM3U8Segment[]
    /** m3u8每个segment的切片时长（秒） */
    targetDuration: number
    /** m3u8-parser版本号 */
    version: number
}

function fetchM3U8File(url: string): Promise<IM3U8ParsedInfo> {
    return fetch(url, {
        headers: {
            'Content-Type': 'application/vnd.apple.mpegurl',
        }
    })
        .then(resp => {
            return resp.text()
        })
        .catch(err => {
            return err
        })
}

function getTSSegment(url: string, bytes: string, onProgress: Function):Promise<ArrayBuffer> {
    return new Promise((resolve) => {
        const request = new XMLHttpRequest();
        let loaded = 0;
        let startTime = Date.now();
        request.onprogress = (evt) => {
            const speed = Math.round(evt.loaded - loaded) / (Date.now() - startTime)
            loaded = evt.loaded
            startTime = Date.now()
            // 每秒多少Kb
            if (typeof onProgress === 'function') onProgress(Math.round((speed * 1000) / 1024))
        }

        request.onload = () => {
            resolve(request.response)
        }

        request.open("GET", url)
        request.setRequestHeader("range", `bytes=${bytes}`)
        request.responseType = "arraybuffer"
        request.send()
    })
}

// 文档参考：https://github.com/video-dev/hls.js/blob/master/docs/API.md
// @ts-ignore
export function getHlsConfig(initParams) {
    const {
        m3u8Path,
        onProgress,
        onError
    } = initParams

    /*
    *自定义获取m3u8文件
    */
    // @ts-ignore
    class pLoader extends Hls.DefaultConfig.loader {
        constructor(config) {
            super(config)
            // @ts-ignore
            this.load = function loader(context, config, callbacks) {
                if (context.type === 'manifest') {
                    const onSuccess = callbacks.onSuccess
                    callbacks.onSuccess = function onLoaderSuccess(response, stats, context) {
                        logs('[边下边播][m3u8加载成功]:', { ...stats, ...response })
                        onSuccess(response, stats, context)
                    }
                }

                const url = m3u8Path
                logs('[边下边播][m3u8开始加载]:', url)
                fetchM3U8File(url).then((text) => {
                    const response = {
                        data: text,
                        url
                    }

                    callbacks.onSuccess(response, {
                        // @ts-ignore
                        loaded: response.data.length,
                        // @ts-ignore
                        total: response.data.length
                    }, context)
                }).catch(error => {
                    console.error(error)
                    callbacks.onError(error, context)
                    onError && onError(error)
                })
            }
        }
    }

    /*
    *自定义Hls加载ts文件分片
    */
    // @ts-ignore
    class fLoader extends Hls.DefaultConfig.loader {
        constructor(config) {
            super(config)
            // @ts-ignore
            this.load = async function loader(context, config, callbacks) {
                let tsSegmentUrl = context.url
                const range = `${context.rangeStart}-${context.rangeEnd}`
                logs('[边下边播][加载Segment]', range, tsSegmentUrl)

                const onSuccess = callbacks.onSuccess
                callbacks.onSuccess = function onLoaderSuccess(response, stats, context) {
                    logs(`[边下边播][${tsSegmentUrl}加载成功]:`, stats, response.data.byteLength)
                    onSuccess(response, stats, context)
                }
                getTSSegment(tsSegmentUrl, range, onProgress)

                // fetch(tsSegmentUrl, {
                //     "headers": {
                //         "range": `bytes=${range}`
                //     },
                //     "referrer": "",
                //     "referrerPolicy": "strict-origin-when-cross-origin",
                //     "body": null,
                //     "method": "GET",
                //     "mode": "cors",
                //     "credentials": "omit"
                // })

                //     .then(response => response.arrayBuffer())
                    .then((buffer) => {
                        console.log(buffer)
                        const response = {
                            data: buffer,
                            url: tsSegmentUrl
                        }
                        const stats = {
                            loaded: response.data.byteLength,
                            total: response.data.byteLength,
                            retry: 0
                        }
                        callbacks.onSuccess(response, stats, context)
                    }).catch(error => {
                        console.error(error)
                        callbacks.onError(error, context)
                        onError && onError(error)
                    })
            }
        }
    }

    return {
        pLoader,
        fLoader,
        maxBufferLength: 120
    }
}

export function msec2sec(msec) {
    let sec = (msec / 1000).toFixed(3);
    return parseFloat(sec);
}

export function initPlaylist(sourceData) {
    if (!sourceData) {
        return;
    }
    // const data = new M3U8Parser(sourceData);
    // console.log('playlist', data)
    // let segments = data.segments;
    // segments.forEach((item, index) => {
    //     if (index === 0) {
    //         // @ts-ignore
    //         item.file = item.file.replace(/\?[\d]+-/, "?0-");
    //     }
    //     // @ts-ignore
    //     item.start = msec2sec(item.start);
    //     // @ts-ignore
    //     item.end = msec2sec(item.end);
    //     // @ts-ignore
    //     item.duration = msec2sec(item.duration);
    // });
    // this.segments = segments;
}